import { Chart } from "chart.js";
import "chartjs-plugin-annotation";
import 'chartjs-adapter-moment';

Chart.defaults.plugins.legend.display = false;
